import React, {useState, useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import useFetchData from '../../crud/useFetchData';
import {proto,url} from '../../Helpers/api';
import {get,groupBy,uniqBy,sortBy} from 'lodash-es';
// import Tabela from './Tabela';
import Seletor from '../Seletor';
import DataTable from '../../Common/DataTable';
import {formataMoeda} from '../../Helpers/money';
import {mesesExtenso} from '../../Helpers/date';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';


export default function Dre (props) {
  let { empresa, mes, ano } = props;
  let empresaId = empresa.value;

  let data;

  const f = useFetchData(`${proto}://${url}/pessoal/dre/${empresaId}/${ano}/${mes}`)
  // const f = useFetchData(`${proto}://${url}/pessoal/dre/${empresaId}/lista`)
  // const d = useFetchData(`${proto}://${url}/pessoal/dpto/${empresaId}`)
  if (get(f,"isFinished")) {
  // if (get(f,"isFinished") && get(d,"isFinished")) {
    data = get(f,"data",[]);
  }
  if (get(f,"isLoading")) return <div>Carregando dados...</div>
  if (get(f,"error")) return <div>Erro ao carregar dados!</div>
  if (!data) return <div>Aguarde...</div>
  let resumoDados = groupBy(data, "SEQUENCIA")
  resumoDados = Object.entries(resumoDados).map(([idSeq,listSeq]) => {
    if (!listSeq.length) return null
    return {
      SEQUENCIA: idSeq,
      NOMEGRUPO: listSeq[0].NOMEGRUPO,
      TOTAL: listSeq.map(e=>e.Saldo).reduce((p,c) => p+c,0)
    }
  })
  return (
    <div>

      <DataTable 
        cols={["auto", "auto", "auto"]}
        // comps={{
        //   Codigo: Teste({value:selecteds, onChange:setSelecteds })
        // }}
        title={["SEQUENCIA", "Grupo", "TOTAL"]}
        data={resumoDados}
        dataIdx={["SEQUENCIA", "NOMEGRUPO", "TOTAL"]}
        modif={{
          TOTAL: formataMoeda
        }}
      />

      <DataTable 
        cols={["auto", "auto", "auto"]}
        // comps={{
        //   Codigo: Teste({value:selecteds, onChange:setSelecteds })
        // }}
        title={["Grupo", "Conta", "Saldo"]}
        data={data}
        dataIdx={["NOMEGRUPO", "NOMECONTA", "Saldo"]}
        modif={{
          Saldo: formataMoeda
        }}
      />
      {/* <Tabela
        empresaId={empresaId}
        funcionarios={funcionarios}
      /> */}
    </div>
  )
}


